// Canal por el que entran las conversaciones de una campaña CHAT.
export enum ChatChannel {
  WHATSAPP = 'WHATSAPP',
  WEBCHAT = 'WEBCHAT',
}
